// Document Metadata Service - Manages document categorization via SharePoint list

export const initializeDocumentMetadata = async (service) => {
  const listName = "FileID";

  try {
    // Check if list exists
    await service.getListItems(listName);
    console.log("✓ FileID list exists");
    return true;
  } catch (e) {
    // List doesn't exist, try to create it
    console.log("FileID list not found. Attempting to create...");
    try {
      await createDocumentMetadataList(service);
      console.log("✓ FileID list created successfully");
      return true;
    } catch (createError) {
      console.warn("Could not auto-create FileID list:", createError);
      console.warn("Please create it manually in SharePoint, or try refreshing the page to retry.");
      return false;
    }
  }
};

const createDocumentMetadataList = async (service) => {
  try {
    // Create the list using Microsoft Graph API
    await service.createList(
      "FileID",
      "Stores document type and categorization metadata"
    );

    // The Graph API creates the list but we also need to add custom columns
    // For now, items can be created with the following fields:
    // FileID, FilePath, DocumentType, CreatedDate, LastCategoryChange
    // SharePoint will create the columns automatically as we add items

    // Create a test item to verify the list works and trigger column creation
    await new Promise(resolve => setTimeout(resolve, 1000)); // Wait for list to be ready

    await service.createListItem("FileID", {
      Title: "System",
      FileID: "INIT",
      FilePath: "init",
      DocumentType: "contract_draft",
      CreatedDate: new Date().toISOString(),
    });

    // Delete the init item
    const items = await service.getListItems("FileID");
    const initItem = items?.value?.find(i => i.fields?.FileID === "INIT");
    if (initItem) {
      await service.deleteListItem("FileID", initItem.id);
    }

    return true;
  } catch (e) {
    throw new Error("Unable to create FileID list: " + e.message);
  }
};

export const getDocumentMetadata = async (service, fileId) => {
  try {
    const items = await service.getListItems("FileID",
      `fields/FileID eq '${fileId}'`);
    return items?.value?.[0];
  } catch (e) {
    console.warn("Error fetching document metadata:", e);
    return null;
  }
};

export const createDocumentMetadata = async (service, fileId, filePath, documentType) => {
  try {
    return await service.createListItem("FileID", {
      FileID: fileId,
      FilePath: filePath,
      DocumentType: documentType,
      CreatedDate: new Date().toISOString(),
    });
  } catch (e) {
    console.warn("Failed to create document metadata:", e);
    return null;
  }
};

export const updateDocumentMetadata = async (service, metadataId, updates) => {
  try {
    return await service.updateListItem("FileID", metadataId, {
      ...updates,
      LastCategoryChange: new Date().toISOString(),
    });
  } catch (e) {
    console.warn("Failed to update document metadata:", e);
    throw e;
  }
};
